'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [],
        _n = !0,
        _d = !1,
        _e = void 0;

    try {
      for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), !(i && _arr.length === i)); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        !_n && _i['return'] && _i['return']();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) return arr;
    if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
    throw new TypeError('Invalid attempt to destructure non-iterable instance');
  };
}(),
    _inherited = require('css-initials/inherited'),
    _inherited2 = _interopRequireDefault(_inherited),
    _utils = require('../utils');

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.resetInheritedStylesObject = void 0;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  return key in obj ? Object.defineProperty(obj, key, {
    value: value,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : obj[key] = value, obj;
}

var snakeToCamel = function snakeToCamel(s) {
  return s.replace(/(-\w)/g, function (m) {
    return m[1].toUpperCase();
  });
},
    modifyStyles = function modifyStyles(obj) {
  return (0, _utils.entries)(obj).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return 'text-align' === key ? [key, 'left'] : [key, value];
  }).reduce(function (o, _ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        k = _ref4[0],
        v = _ref4[1];

    return _extends({}, o, _defineProperty({}, k, v));
  }, {});
},
    toCSS = function toCSS(obj) {
  return Object.keys(obj).map(function (key) {
    return key + ': ' + obj[key] + ';';
  }).join('\n');
},
    toObject = function toObject(obj) {
  return (0, _utils.entries)(obj).map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    return [snakeToCamel(key), value];
  }).reduce(function (o, _ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        k = _ref8[0],
        v = _ref8[1];

    return _extends({}, o, _defineProperty({}, k, v));
  }, {});
},
    modifiedStyles = modifyStyles(_inherited2.default),
    resetInheritedStyles = '\n  ' + toCSS(modifiedStyles) + '\n',
    resetInheritedStylesObject = exports.resetInheritedStylesObject = toObject(modifiedStyles);

exports.default = resetInheritedStyles;